import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    Screenfull: Screenfull
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'name', 'avatar'])), mapState({
    isReal: function isReal(state) {
      return state.user.isReal;
    },
    realFilter: function realFilter(state) {
      return state.user.realFilter;
    },
    isRefresh: function isRefresh(state) {
      return state.user.refreshInfo.alarmRefresh;
    }
  })),
  beforeDestroy: function beforeDestroy() {},
  methods: {
    handSelect: function handSelect(index, path) {
      this.$router.push({
        name: index
      });
    },
    getThisTime: function getThisTime() {
      var _this = this;

      fetchthisTime().then(function (r) {
        _this.thisTime = r.data.data;

        _this.handleInterval();
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('toggleSideBar');
    },
    logout: function logout() {
      var _this2 = this;

      this.$confirm('准备退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$store.dispatch('LogOut').then(function () {
          // location.href = 'http://' + window.location.host + '/login'
          location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
        });
      }).catch(function () {});
    },
    main: function main() {
      this.$router.push({
        name: 'Admindashboard'
      });
    }
  }
};